import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';
import { configByEnv } from '@bridebook/toolbox/src/gazetteer/buckets/config-by-env';

const result: PartialRecursive<IBucket['settings']> = {
  hasEssentials: {
    types: {
      included: ['venue'],
    },
  },
  // Each table applies from its tier upwards, so the tiers in between fall to the one below
  chargebeePricingTable: {
    venue: {
      tableIdByMinTier: configByEnv({
        dev: {
          [PremiumTiers.Unverified]: 'PkywguKy8n',
          [PremiumTiers.Tier_2]: 'pE92rfQKkp',
          [PremiumTiers.Tier_3]: 'pdxq7TAmRp',
        },
        live: {
          [PremiumTiers.Unverified]: 'p3NLlURbDn',
          [PremiumTiers.Tier_2]: 'n4Ag7UWa8p',
          [PremiumTiers.Tier_3]: 'P9yeBcjKYP',
        },
      }),
    },
  },
  freeTrial: {
    suppliers: {
      tier: PremiumTiers.Tier_1,
      days: 90,
      activation: 'signup',
    },
    venue: {
      tier: PremiumTiers.Tier_0_25,
      days: 60,
      activation: 'signup',
    },
  },
  hideLimitedProfiles: {
    types: {
      included: ['venue'],
    },
  },
  searchFilters: {
    venue: {
      overviewSection: [
        'highestReviewed',
        'exclusiveUse',
        'weddingLicence',
        'hasAccommodation',
        'lateNightExtensionAvailable',
        'alcoholLicense',
      ],
      venueType: [
        'countryHouseManorHouse',
        'barn',
        'gardenOutdoor',
        'statelyHome',
        'castle',
        'hotel',
        'cityHotelCityVenue',
        'warehouseFactory',
        'museumAttraction',
        'pubRestaurant',
        'golfCourse',
        'cruiseBoatYacht',
        'sportingVenueStadium',
        'conferenceCentre',
        'placeOfWorship',
        'townHallRegistryOffice',
        'otherVenueType',
      ],
    },
  },
  smartPricing: {
    types: {
      included: ['venue'],
    },
  },
};

export default result;
